



import { Component, Vue } from 'vue-property-decorator';

import ItemThumb from '@/shared/components/item-thumb.component.vue';
import Assets from '@/constants/assets.ts';

@Component({
    components: {
        ItemThumb,
    },
})

export default class ItemThumbPartial extends Vue {
  private assets = Assets;
}
